<template>
    <v-app class="white">
        <div 
        v-show="mShowLogo"
        class="logo-img-position">
          <img 
          src="@/assets/intro_logo.png"
          class="img-logo"> 
        </div>
        <div 
        @click.passive="onClickLogin"
        v-ripple="{ center: true, class: `teal--text`  }"
        v-show="mShowLogo"
        class="google-position">
          <img 
          src="@/assets/google_login.png"
          class="img-google-login"> 
        </div>  
      <div class="loading-bar-postion" :hidden="mShowLoading">
        <v-progress-circular
          indeterminate
          color="red"
        ></v-progress-circular>
      </div>
      <div class=txt-error-position>{{mTxtError}}</div>
    </v-app>
</template>
<script>
import HttpMsg from '../mixin/HttpMsg';
import axios from 'axios';
export default {
  created() {
    if(navigator.userAgent.indexOf("KAKAOTALK") != -1) {
        this.mTxtError = this.$t('no_kakao');
      return;
    }
    this.mShowLogo = true;
    if(navigator.platform){
      var filter = "win16|win32|win64|mac";
      if(0 > filter.indexOf(navigator.platform.toLowerCase())){
      } else {
        this.mTxtError = this.$t('no_pc');
        this.mShowLogo = false;
      }
    }

    let autoLogin = this.$route.query.auto_login;
    if(autoLogin == 1) { // 자동로그인
      this.mShowLogo = false;
      let email = this.$route.query.email;
      let snskey = this.$route.query.sns_key;
      var json = {};
      json.cmd = "sign-in";
      json.account = email;
      json.sns_key = snskey;
      console.log("" + JSON.stringify(json))
      this.mEmail = email;
      this.loginServer(JSON.stringify(json));
    } 
  },
  mixins: [ HttpMsg ],
  data: () => ({
    mShowLoading : true,
    mEmail : "",
    mLoginKey : "",
    mTxtError : "",
    mShowLogo : true,
  }),
  methods : {
    onClickLogin : function() {
      this.$gAuth.signIn() // 구글로그인
      .then(googleUser => {
        console.log('user', googleUser)
        var json = {};
        json.cmd = "sign-in";
        json.account = googleUser.w3.U3;
        json.sns_key = googleUser.w3.Eea;
        this.mEmail = googleUser.w3.U3;
        this.loginServer(JSON.stringify(json));
      })
      .catch(error  => {
        console.log('error' + JSON.stringify(error) )
      })
    },
    onSuccess(googleUser) {
      console.log(googleUser);
    },
    onFailure(googleUser) {
        console.log(googleUser);
    },
    loginServer(reqDataJson) { // 로그인하기
    console.log("loginServer")
      this.mShowLoading = false;
      axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(reqDataJson), "K"))
        .then(response => {
          console.log("loginServer" + JSON.stringify(response) )
          this.mShowLoading = true;       
          let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));   
          console.log("=========" + JSON.stringify(serverResponse))
          if(serverResponse.result == "1") { // 성공
            console.log(response)
            let payload = {};
            payload.mno = serverResponse.mno;
            payload.email = this.mEmail;
            payload.notice = serverResponse.notice;
            payload.login_key = serverResponse.login_key;
            let payloadJson = JSON.stringify(payload);
            let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
            this.$router.replace( { path : 'wallet_list', query: { payload: crypto }  } );
          } else if(serverResponse.result == "2") { // 신규가입유도
            this.signUp(reqDataJson, serverResponse.list);
          } else if(serverResponse.result == "9") { // 비밀번호 변경
            this.chagePasswd(serverResponse.mno);
          } else if(serverResponse.result == "0") { // 오류
            alert(serverResponse.message);
          }
        })
        .catch( ()=>{} );
    },
    signUp(reqDataJson, referral) { // 신규가입
      let jsonReq = JSON.parse(reqDataJson);
      let payload = {};
      payload.account = jsonReq.account;
      payload.sns_key = jsonReq.sns_key;
      payload.referral = referral;
      let payloadJson = JSON.stringify(payload);
      let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
      this.$router.push( { path : 'signup', query: { payload : crypto } } );
    },
    chagePasswd : function(mno) {
      alert(this.$t('after_retry_login'));
      let payload = {};
      payload.mno = mno;
      payload.mode = 1;
      let payloadJson = JSON.stringify(payload);
      let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
      this.$router.push( { path : 'charge_passwd', query: { payload : crypto } } );
    }
  },
}
</script>
<style scoped>
* {
  margin: 0;
  font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
  font-weight: 300;
  padding: 0;
}
html, body {
  height: 100vh;
  width: 100vw;
}
.img-logo {
  height: 32.22vw;
  width: 55.8vw;
}
.logo-img-position {
  position: absolute;
  top: 30.8vh;
  left: 22.1vw;
}
.copyright-position {
  position: absolute;
  bottom: 4.2vh;
  left: 15.88889vw;
}
.img-copyright {
  height: 3.3vw;
  width: 68.5vw;
}
.google-position {
  position: absolute;
  top: 54vh;
  left: 20.2vw; 
  height: 10.27vw;
  width: 59.7vw;
}
.img-google {
  height: 10.27vw;
  width: 59.7vw;
}
.img-google-login {
  height: 10.27vw;
  width: auto;
}
.loading-bar-postion {
  position: absolute;
  top: 50vh;
  left: 50vw; 
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%); 
}
.txt-error-position {
  position: absolute;
  top: 10vw;
  left: 0vw; 
  width: 100vw;
  font-size: 5vw;
  text-align: center;
  color: brown;
}
</style>